
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import StateButton from '@/components/inputs/StateButton.vue';

import programx from '@/store/modules/programx';
import mwx from '@/store/modules/mediumwarex';
import progressToastx from '@/store/modules/progressToastx';

import {
	SoftwareType,
	ProgramData,
	EditState,
	AddProgramSubmission,
} from '@/store/models.def';

@Component({
	components: {
		StateButton,
	},
})
export default class AddProgram extends Vue {
	public programId = '';
	public softwareType: SoftwareType = 'sql';

	public validateNow = false;
	public addProgramState: EditState = 'active';

	public get softwareTypesVt() {
		return mwx.softwareTypesVt;
	}
	public get prefix() {
		return `${this.softwareType}-`;
	}
	public get id() {
		return `${this.prefix}${this.programId}`;
	}
	public get validateProgramId() {
		if (!this.validateNow) {
			return null;
		}
		if (this.programId.length === 0) {
			return false;
		}
		// check existing name
		if (programx.allPrograms.find((pg) => pg.id === this.id)) {
			return false;
		}
		return true;
	}
	public get addProgramLabel() {
		const labels = {
			active: 'Add New Program',
			sending: 'Adding...',
			done: 'Added New Program',
		};
		return labels[this.addProgramState];
	}
	public async addProgram() {
		if (this.addProgramState !== 'active') {
			return;
		}
		this.validateNow = true;
		if (!this.validateProgramId) {
			return;
		}
		const submission: AddProgramSubmission = {
			id: this.id,
			softwareType: this.softwareType,
		};
		const toastId = await progressToastx.add({
			title: `${this.id}`,
			state: `Adding new program...`,
			variant: 'info',
		});
		this.addProgramState = 'sending';
		this.validateNow = false;
		const result = await programx.addProgram(submission);
		this.addProgramState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `New program added!` });
			this.programId = '';
		} else {
			this.validateNow = true;
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
}
